import { resolveQuality } from "../systems/quality";
import type { KnowledgePanel } from "../ui/knowledge";
import { mountCurriculum } from "../ui/curriculum";
import { SITE } from "../brand/config";
import { CLUB, CHAPTER_STAINS } from "../brand/club";
import { mountLeafFractal, type LeafFractalHandle } from "../ui/leafFractal";

export type LearnHandle = {
  destroy: () => void;
};

export function mountLearn(app: HTMLElement, panel: KnowledgePanel): LearnHandle {
  let leaf: LeafFractalHandle | null = null;
  let destroyed = false;
  let curriculumDestroy: (() => void) | undefined;

  const onChapter = (e: Event) => {
    const chapter = (e as CustomEvent<{ chapter?: string }>).detail?.chapter;
    const stain = chapter ? CHAPTER_STAINS[chapter]?.stain : undefined;
    leaf?.setAccent(stain);
  };

  app.innerHTML = `<div class="learn-loading" style="padding:48px 24px;color:#c9a227;font-family:Syne,sans-serif;letter-spacing:.04em;font-size:1rem">Opening Club cannac…</div>`;

  void mountCurriculum(app, panel).then((handle) => {
    if (destroyed) {
      handle.destroy?.();
      return;
    }
    curriculumDestroy = handle.destroy;
    const canvas = handle.canvas;
    const quality = resolveQuality();
    try {
      if (!quality.reducedMotion) {
        leaf = mountLeafFractal(canvas, { intensity: "subtle" });
        canvas.classList.add("leaf-fractal-canvas");
      } else {
        // Still paint one quiet frame
        leaf = mountLeafFractal(canvas, { intensity: "subtle" });
        canvas.classList.add("leaf-fractal-canvas");
      }
    } catch {
      canvas.style.display = "none";
    }
  });

  document.title = `${CLUB.name} | ${SITE.name}`;
  document.body.style.overflow = "auto";
  document.body.classList.add("is-club");
  window.addEventListener("cannac:chapter", onChapter);

  return {
    destroy: () => {
      destroyed = true;
      window.removeEventListener("cannac:chapter", onChapter);
      curriculumDestroy?.();
      leaf?.destroy();
      leaf = null;
      app.innerHTML = "";
      document.body.style.overflow = "";
      document.body.classList.remove("is-club");
    },
  };
}
